import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../turbo_confirm"

// Slide-over drawer used app-wide. The panel and overlay animate in on connect and
// out on close; the element removes itself once the leave transition finishes.
const TRANSITION_MS = 300

export default class extends Controller {
  static targets = ["form", "panel", "overlay"]

  connect() {
    document.body.style.overflow = "hidden"
    this.closing = false
    this.previouslyFocused = document.activeElement

    this.onKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.onKeydown)

    requestAnimationFrame(() => this.enter())
  }

  disconnect() {
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.onKeydown)
    clearTimeout(this.removalTimeout)
    this.restoreFocus()
  }

  enter() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("translate-x-full")
      this.panelTarget.classList.add("translate-x-0")
      this.panelTarget.focus({ preventScroll: true })
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-0")
      this.overlayTarget.classList.add("opacity-100")
    }
  }

  toggle() {
    if (this.closing) return
    this.closing = true

    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("translate-x-0")
      this.panelTarget.classList.add("translate-x-full")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-100")
      this.overlayTarget.classList.add("opacity-0")
    }

    // Remove once the leave transition finishes, with a timeout fallback in case
    // transitionend never fires (reduced motion, hidden tab).
    this.removalTimeout = setTimeout(() => this.element.remove(), TRANSITION_MS + 50)
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return
    // A nested native dialog (confirm, filter) owns Escape while it is open.
    if (document.querySelector("dialog[open]")) return

    event.preventDefault()
    this.hideCanvasByClickingOnOverlay()
  }

  restoreFocus() {
    const target = this.previouslyFocused
    if (target && target !== document.body && document.contains(target)) {
      target.focus({ preventScroll: true })
    }
  }

  async hideCanvasByClickingOnOverlay() {
    if (this.closing) return

    if (this.hasFormTarget) {
      const userConfirmed = await confirmDialog(
        "Sind Sie sicher, dass Sie das Menü schließen möchten?",
      )
      if (userConfirmed) {
        this.toggle()
      }
    } else {
      this.toggle()
    }
  }
}
